import { Set } from "immutable";

const recordUrl = `https://vq852ax2pd.execute-api.us-east-1.amazonaws.com/production/record`;
const recordsUrl = `https://vq852ax2pd.execute-api.us-east-1.amazonaws.com/production/records`;
const guestAuth = `https://r7m1qdtg4f.execute-api.us-east-2.amazonaws.com/production/guest?guest=`
const ipBatchOperationsUrl = `http://ip-api.com/batch`;

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};

const RequestMethod = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
};

export const ApiConfiguration = {
    getRecord: () => [
        recordsUrl,
        {
            method: RequestMethod.GET,
            headers,
        }
    ],
    createRecord: (accessId, invited, date, device, innerHeight, innerWidth) => [
        recordUrl, 
        {
            method: RequestMethod.PUT,
            headers,
            body: JSON.stringify({
                accessId,
                invited,
                date,
                device,
                innerHeight,
                innerWidth,
            }),
        }
    ],
    updateRecord: (accessId, newRecord) => [
        recordUrl, 
        {
            method: RequestMethod.PATCH,
            headers,
            body: JSON.stringify({accessId, ...newRecord}),
        }
    ],
    externalGetBatchIpLocations: (records) => [
        ipBatchOperationsUrl, 
        {
            method: RequestMethod.POST,
            headers,
            body: JSON.stringify(
                Set(records.map(record => record.source)).toArray().slice(0, 100)
                    .map(source => ({query: source, fields: 'city,regionName,country,isp,query'}))
            )
        }
    ],
    authenticateGuest: (guestName) => [
        guestAuth + guestName,
        {
            method: RequestMethod.GET,
            headers,
        }
    ]
};


